import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'lodash'

import { ConsultaSeguimentoIndicatorResultadoText } from '../../components/ConsultaSeguimentoIndicatorResultado'
import {
  hasAnySim,
  isAllFilled,
  isAllNao,
  isPerguntaOutroFilled,
  isPerguntaOutroSelected,
  isPerguntaOutroSim,
} from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta12ExemplosEnum,
  ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum,
  ConsultaSeguimentoPergunta12Model,
} from './model-consultaSeguimentoPergunta12'

const pergunta12ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta12ExemplosEnum)

const pergunta12ExemplosPassouFalhouEnumValues = Object.values(ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum)

export function isPergunta12ExemplosAllFilled(value: ConsultaSeguimentoPergunta12Model): boolean {
  const isExemplosAllFilled = isAllFilled(value?.PERGUNTA_12_EXEMPLOS, pergunta12ExemplosEnumValues)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosAllFilled && isPerguntaOutroSelected(value?.OUTRO)
  }

  return isExemplosAllFilled
}

export function hasPergunta12ExemplosAtLeastTwoSim(value: ConsultaSeguimentoPergunta12Model): boolean {
  const exemplosMarkedAsSim = Object.values(value?.PERGUNTA_12_EXEMPLOS ?? {}).filter((item) => item === SimNaoEnum.SIM)

  if (isPerguntaOutroSim(value?.OUTRO)) {
    return exemplosMarkedAsSim.length >= 1
  }

  return exemplosMarkedAsSim.length >= 2
}

export function isPergunta12ExemplosPassouFalhouAllFilled(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllFilled(allExemplos, pergunta12ExemplosPassouFalhouEnumValues)
}

export function isPergunta12ExemplosPassouFalhouAllNao(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta12ExemplosPassouFalhouEnumValues)
}

export function hasPergunta12ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta12ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta12Model['PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}

export function getPergunta12ResultadoText(
  value: ConsultaSeguimentoPergunta12Model
): ConsultaSeguimentoIndicatorResultadoText {
  let textResultadoPassou: string
  let textResultadoFalhou: string

  const isExemplosAllFilled = isPergunta12ExemplosAllFilled(value)
  const hasExemplosAtLeastTwoSim = hasPergunta12ExemplosAtLeastTwoSim(value)

  if (value.PERGUNTA_12_HEADER === SimNaoEnum.SIM && isExemplosAllFilled && !hasExemplosAtLeastTwoSim) {
    textResultadoPassou = 'Sim para um ou nenhum:'
  }

  if (value.PERGUNTA_12_HEADER === SimNaoEnum.SIM && hasExemplosAtLeastTwoSim) {
    const hasPerguntaExemplosPassouAnySim = hasPergunta12ExemplosPassouAnySim(value?.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU)
    const hasPerguntaExemplosFalhouAnySim = hasPergunta12ExemplosFalhouAnySim(value?.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU)
    const hasSimOnlyInExemplosPassou = hasPerguntaExemplosPassouAnySim && !hasPerguntaExemplosFalhouAnySim
    const hasSimOnlyInExemplosFalhou = hasPerguntaExemplosFalhouAnySim && !hasPerguntaExemplosPassouAnySim

    textResultadoPassou = hasSimOnlyInExemplosPassou
      ? 'Sim somente para exemplos Passou:'
      : 'Os mais frequentes são exemplos de Passou:'

    textResultadoFalhou = hasSimOnlyInExemplosFalhou
      ? 'Sim somente para exemplos Falhou:'
      : 'Os mais frequentes são exemplos de Falhou:'
  }

  return {
    PASSOU: textResultadoPassou,
    FALHOU: textResultadoFalhou,
  }
}

export function prunePergunta12(value: ConsultaSeguimentoPergunta12Model): ConsultaSeguimentoPergunta12Model {
  const pruned: ConsultaSeguimentoPergunta12Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_12_HEADER: value.PERGUNTA_12_HEADER,
  }

  const isHeaderSim = value.PERGUNTA_12_HEADER === SimNaoEnum.SIM
  const hasAtLeastTwoSim = hasPergunta12ExemplosAtLeastTwoSim(value)
  const hasPassouAnySim = hasPergunta12ExemplosPassouAnySim(value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU)
  const hasFalhouAnySim = hasPergunta12ExemplosFalhouAnySim(value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU)

  if (isHeaderSim) {
    pruned.PERGUNTA_12_EXEMPLOS = value.PERGUNTA_12_EXEMPLOS
  }

  if (isHeaderSim && hasAtLeastTwoSim) {
    pruned.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU = value.PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU
  }

  if (isHeaderSim && hasAtLeastTwoSim && hasPassouAnySim && hasFalhouAnySim) {
    pruned.PERGUNTA_12_FREQUENCIA = value.PERGUNTA_12_FREQUENCIA
  }

  return pruned
}
